import { render, staticRenderFns } from "./KukoProductSearch.vue?vue&type=template&id=a32c113a&"
import script from "./KukoProductSearch.vue?vue&type=script&lang=js&"
export * from "./KukoProductSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports